module.exports = __webpack_public_path__ + "img/img12.7288477a.svg";